@if (showLeftMenuOpener()) {
  <alg-left-header [compactMode]="true" />
}
<alg-content-top-bar [showBreadcrumbs]="showBreadcrumbs()"
  [showLeftMenuOpener]="showLeftMenuOpener()"
 />
@if (showTopRightControls()) {
  <alg-top-right-controls [drawLeftBorder]="!modeBarDisplayed()" />
}
